import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'material-ui/Snackbar';

export default class NoDeviceMessage extends React.Component {
  static propTypes = {
    sourcesCount: PropTypes.number.isRequired,
    navigate: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showMessage: false,
    };
  }

  componentWillMount() {
    this.updateVisibilty(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateVisibilty(nextProps);
  }

  updateVisibilty({ devicesCount, sourcesCount }) {
    const showMessage = !devicesCount && sourcesCount > this.props.sourcesCount;
    this.setState({ showMessage });
  }

  closeMessage() {
    this.setState({ showMessage: false });
  }

  render() {
    return (
      <div className="no-device-message">
        <Snackbar
          open={this.state.showMessage}
          message="Add a device to broadcast the content"
          action="Go to Devices"
          onActionTouchTap={() => this.props.navigate()}
          onRequestClose={() => this.closeMessage()}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/no_device_message/no_device_message.jsx